/**
 * How loudly a notification arrives, and how long it stays.
 *
 * Three separate questions, deliberately not one predicate: an activity feed
 * entry is worth reading later but not worth interrupting for, and a new mail
 * is the exact opposite — worth interrupting for, not worth keeping, because
 * the mail folder's own unread badge already holds the count that outlives it.
 *
 * Kept apart from presenter.js so it can be tested without a browser: the
 * presenter pulls in the i18n filters, this file pulls in nothing.
 */

/**
 * True when the notification counts towards the bell badge.
 *
 * A row written before the priority column existed carries none, and must keep
 * behaving as it did: important.
 */
export function raisesBadge(notification) {
    return notification.priority !== 'info' && notification.priority !== 'transient';
}

/**
 * True when the arrival pops a toast and plays a sound.
 */
export function popsToast(notification) {
    return notification.priority !== 'info';
}

/**
 * True when the notification stays in the inbox after it was shown.
 */
export function staysInInbox(notification) {
    return notification.priority !== 'transient';
}
